// 🔐 Login / Register / Welcome
// Goal: fast, frictionless entry.
// Use Clerk components (SignIn / SignUp).
// Minimal layout: centered card on neutral background.
// Branding: small logo.
// CTA → "Sign in with Google" as primary button.
// 👉 Best practice: no extra fields — auth first, profile later.

import { createFileRoute } from '@tanstack/react-router';
import { SignIn } from '@clerk/clerk-react';
import { z } from 'zod';

const searchParamsSchema = z.object({
  from: z.string().optional(),
  redirect: z.string().optional(), // For invitation acceptance flow
});

export const Route = createFileRoute('/login')({
  validateSearch: searchParamsSchema,
  component: Login,
});

function Login() {
  const { from, redirect } = Route.useSearch();

  // Priority: redirect param > from param > default to /
  const redirectUrl = redirect || from || '/';

  return (
    <div className="bg-muted/50 flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-8 p-8">
        {/* Clerk Sign In */}
        <div className="flex justify-center">
          <SignIn
            appearance={{
              elements: {
                formButtonPrimary: 'bg-primary hover:bg-primary/90',
                card: 'shadow-sm',
              },
            }}
            redirectUrl={redirectUrl}
          />
        </div>
      </div>
    </div>
  );
}
